module.exports = __webpack_public_path__ + "static/media/leclerc6.8d0028d8.jpg";